export default __webpack_public_path__ + "static/media/edit_image.5c89ed37.svg";